import { Translator } from 'Translator';

const langCode = Translator.getLanguageCode();
const langCodes = require('resources/languages.json');

export const makeLocalizedUrl = (source) => {
  let localizedUrl = source;
  const [first, ...rest] = source.match(/([^/]+)/g);
  if (langCodes.includes(first)) {
    if (first !== langCode && langCode !== 'en') {
      localizedUrl = '/' + [langCode, ...rest].join('/');
    }
  } else {
    localizedUrl = `${langCode !== 'en' ? `/${langCode}` : ''}${source}`;
  }
  return localizedUrl;
};
